export default __webpack_public_path__ + "static/N0315-120faa5055a75761cc5a0f3d1771f1fc.png";